const Types = {
	WORKSPACE_SET_LIST_ORGANIZATION: 'WORKSPACE_SET_LIST_ORGANIZATION',
	WORKSPACE_FILTER_COMPANY_LIST_ORGANIZATION: 'WORKSPACE_FILTER_COMPANY_LIST_ORGANIZATION',
	WORKSPACE_REMOVE_ORGANIZATION: 'WORKSPACE_REMOVE_ORGANIZATION',
	WORKSPACE_ADD_ORGANIZATION: 'WORKSPACE_ADD_ORGANIZATION',
	WORKSPACE_ADD_COMPANY_LIST_ORGANIZATION: 'WORKSPACE_ADD_COMPANY_LIST_ORGANIZATION'
};

export default Types;
